import { render, staticRenderFns } from "./SalesPaymentViewLogs.vue?vue&type=template&id=3a12e321"
import script from "./SalesPaymentViewLogs.vue?vue&type=script&lang=js"
export * from "./SalesPaymentViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports